var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showTooltip)?_c('div',{staticClass:"map-item-tooltip tooltip b-tooltip bs-tooltip-top",style:(_vm.tooltipPosition)},[_c('div',{staticClass:"arrow",style:(_vm.getArrowStyle)}),_c('div',{staticClass:"tooltip-inner",style:(_vm.getStyle)},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }